import { render, staticRenderFns } from "./TaskDueDateTime.vue?vue&type=template&id=38d40936&scoped=true&"
import script from "./TaskDueDateTime.vue?vue&type=script&lang=ts&"
export * from "./TaskDueDateTime.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDueDateTime.vue?vue&type=style&index=0&id=38d40936&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d40936",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
